import React from 'react';

import { Box, LinearProgress, useMediaQuery } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    loaderMain: {
        width: '100%',
        height: '100%',
        flex: '1 1',
        display: 'flex',
        justifyContent: 'center',
    },
    logo: {
        width: '100%',
    },
}));

const BigLoader = () => {
    const classes = useStyles();
    const gutterTop = !useMediaQuery('(max-height:400px)');

    return (
        <Box className={classes.loaderMain} pt={gutterTop ? 25 : 8}>
            <Box width={300} textAlign="center">
                <LinearProgress />
            </Box>
        </Box>
    );
};

export default BigLoader;
